import { ROLE_TYPE_PROVIDER } from "../../../constants/RegisterConstants";
import ResidentEntryLogPageContent from "../components/ResidentEntryLogPageContent";

const ProviderDailyNotesPage = () => (
  <ResidentEntryLogPageContent
    expectedRole={ROLE_TYPE_PROVIDER}
    entryType="daily_note"
    pageTitle="Progress Notes"
    pageSubtitle="Keep a simple running note of the day, the shift, and anything helpful for follow-up."
    sectionTitle="Progress Notes"
    sectionDescription=""
    defaultComposerVisible={true}
    showComposerToggleButton={true}
    compactActionBar={true}
    compactDraftsAction={true}
    loadEntriesPage={(backendAPIStore, residentId, options) =>
      backendAPIStore.getResidentDailyNotesPage(residentId, options)}
    createEntry={(backendAPIStore, residentId, payload) =>
      backendAPIStore.createResidentDailyNote(residentId, payload)}
    updateEntry={(backendAPIStore, residentId, payload) =>
      backendAPIStore.updateResidentDailyNote(residentId, payload)}
    deleteDraft={(backendAPIStore, residentId, entryLogId) =>
      backendAPIStore.deleteResidentDailyNote(residentId, entryLogId)}
    canEditEntry={() => true}
    enableMonthlyReport={true}
    monthlyReportTitle="Generate Reports"
    monthlyReportDescription="Review the month's progress notes and export a simple report for follow-up and recordkeeping."
    loadMonthlyReport={(backendAPIStore, residentId, options) =>
      backendAPIStore.getResidentDailyNotesMonthlyDataset(residentId, options)}
    generateMonthlyReportDocument={(backendAPIStore, residentId, requestBody) =>
      backendAPIStore.generateResidentDailyNotesReportDocument(residentId, requestBody)}
    readOnlyArchivedResident={true}
  />
);

export default ProviderDailyNotesPage;
